// Domain
const DOMAIN =
  'lending.services.public.onboarding.lzOnboarding.contractContainer.contractFlowsConfiguration.';

const PDF_ATTACH = `${DOMAIN}referPDFAttachment`;

export { PDF_ATTACH, DOMAIN };
